import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Link, useNavigate } from 'react-router-dom';
import { FaGoogle, FaFacebookF } from 'react-icons/fa';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './SignIn.css'; // Reusing SignUp styles
import { API_URLS } from '../../../config/api';
import logo from '../../../images/logo.png';

const SignIn = ({ onSuccess, onClose }) => {
  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMsg, setForgotMsg] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError('Please fill in all fields.');
      return;
    }
    try {
      const res = await fetch(API_URLS.LOGIN, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Login error');
      } else {
        setSuccess('Login successful!');
        if (data.token) {
          localStorage.setItem('token', data.token);
          window.dispatchEvent(new Event('storage'));
        }
        
        setTimeout(() => {
          if (onSuccess) {
            onSuccess(); // Call callback for modal window
          } else {
            navigate('/'); // Default redirect if not modal window
          }
        }, 1000);
      }
    } catch (err) {
      setError('Server connection error');
    }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setForgotMsg('');
    if (!forgotEmail) {
      setForgotMsg('Enter email');
      return;
    }
    try {
      const res = await fetch(API_URLS.FORGOT_PASSWORD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail })
      });
      const data = await res.json();
      if (!res.ok) {
        setForgotMsg(data.error || 'Email sending error');
      } else {
        setForgotMsg(data.message || 'Instructions sent to email');
      }
    } catch (err) {
      setForgotMsg('Server connection error');
    }
  };

  const handleGoogleSuccess = (credentialResponse) => {
    fetch(API_URLS.GOOGLE_AUTH, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ credential: credentialResponse.credential })
    })
    .then(res => res.json())
    .then(data => {
      if (data.token) {
        localStorage.setItem('token', data.token);
        window.dispatchEvent(new Event('storage'));
        
        if (onSuccess) {
          onSuccess(); // Call callback for modal window
        } else {
          navigate('/'); // Default redirect if not modal window
        }
      } else {
        setError(data.error || 'Google login error');
      }
    });
  };

  return (
    
      <div className="signup-container">
        <div className="signup-logo">
          <img src={logo} alt="Pryvitai Logo" style={{ height: '50px' }} />
        </div>

        {!showForgot ? (
          <>
            <h2>Sign In to Profile</h2>
     
             
        {/* <GoogleOAuthProvider clientId="411952234902-th0g5fji6s9cept1tkqmdn8qj5brivhc.apps.googleusercontent.com">
          <GoogleLogin
            onSuccess={credentialResponse => {
              fetch(API_URLS.GOOGLE_AUTH, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ credential: credentialResponse.credential })
              })
                .then(res => res.json())
                .then(data => {
                  if (data.token) {
                    localStorage.setItem('token', data.token);
                    window.dispatchEvent(new Event('storage'));
                    
                    if (onSuccess) {
                      onSuccess(); // Call callback for modal window
                    } else {
                      navigate('/'); // Default redirect if not modal window
                    }
                  } else {
                    alert(data.error || 'Google login error');
                  }
                });
            }}
            onError={() => {
              console.log('Google Sign In Failed');
            }}
            text="signin_with"
          />
        </GoogleOAuthProvider>
     
          

            <div className="divider">OR</div> */}

            <form className="signup-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="im'ya@example.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="password">Password</label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    value={form.password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>
              
              <div className="forgot-password-link">
                <button className="forgot-password-button" type="button" onClick={() => setShowForgot(true)}>
                  Forgot password?
                </button>
              </div>

              {error && <p className="error-message">{error}</p>}
              {success && <p className="success-message">{success}</p>}

              <button type="submit" className="submit-btn">Sign In</button>
            </form>

            <p className="login-link">
              Don't have an account? <Link to="/SignUp">Sign Up</Link>
            </p>
          </>
        ) : (
          <>
            <h2>Password Recovery</h2>
            <p className="forgot-password-info">Enter your email address and we will send you password recovery instructions.</p>
            <form className="signup-form" onSubmit={handleForgot}>
              <div className="input-group">
                <label htmlFor="forgotEmail">Email</label>
                <input
                  type="email"
                  id="forgotEmail"
                  name="forgotEmail"
                  placeholder="name@example.com"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                />
              </div>
              {forgotMsg && <p className={forgotMsg.includes('error') ? "error-message" : "success-message"}>{forgotMsg}</p>}
              <button type="submit" className="submit-btn">Send</button>
            </form>
            <p className="login-link">
              <button type="button" onClick={() => setShowForgot(false)}>
                Return to sign in
              </button>
            </p>
          </>
        )}
      </div>
   
  );
};

export default SignIn;
